<template>
  <v-col align="start">
    <v-col>
      <v-icon large class="primary--text" @click="reload()">mdi-close-circle</v-icon>
    </v-col>
    <v-row>
      <v-col align="start">
        <h1 class="mb-4">Choose waste type 
          <a style="font-size: 24px; font-weight: lighter;" @click="show = !show" class="primary--text"> - {{show ? 'Hide info' : 'Waste type info?'}} </a>
        </h1>
      </v-col>
    </v-row>
    <br/>
    <v-container>
      <v-row v-for="service in services" v-bind:key="service.key" class="mb-2" justify="start" align="start">
        <v-card elevation="10" width="500" v-on:click="service.onClick()" :class="service.isSelected ? 'grey darken-3 primary--text' : 'white black--text'">
          <v-container>
            <v-row justify="center">     
              <v-col align="center">
                <p>{{ service.name }}</p>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-row>
      <v-row class="mx-1" justify="start">
        <v-col align="start">
          <v-btn
            height="55"
            class="btn"
            style="border-radius: 30px;"
            v-bind:disabled="!canProceed"
            v-on:click="selectWasteType"
            color="primary"
        >Continue</v-btn>
        </v-col> 
      </v-row>
      <v-row v-if="show">
        <v-col>
          <wasteType/>
        </v-col>
      </v-row>
    </v-container>
  </v-col>
</template>

<script>
import wasteType from '@/components/wasteType.vue';
export default {
  name: "WasteType",
  components:{
    wasteType
  },
  props: {
    proceed: Function,
    wasteTypes: Array
  },
  data() {
    return {
      services: [],
      selectedServiceType: {},
      canProceed: false,
      show: false
    }
  },
  watch: {
    selectedServiceType () {
      this.canProceed = true;
    }
  },
  methods: {
    reload(){
      scrollTo(0, 0);
      this.$router.go();
    },
    selectService(service) {
      this.services.forEach( s =>  {
        s.isSelected = s.key === service;
        if (s.isSelected) {
          this.selectedServiceType = s;
        }
      });
    },
    selectWasteType() {
      this.proceed(this.selectedServiceType);
      scrollTo(0, 0);
    },

  },
  mounted() {
    this.wasteTypes.forEach( (v) => {
      this.services.push( {...v, isSelected: false, onClick: () => this.selectService(v.key) });
    });
  }
}
</script>

<style scoped>
.btn{
  width: 426px;
}
@media screen and (max-width: 480px){
  .btn{
    width: 100%;
  }

}
</style>